import React, { useState, useEffect } from 'react';
import { CheckCircle2, Circle, Instagram } from 'lucide-react';

const ConnectInstagramPanel = ({ onConnect }) => (
  <div
    className="mt-2 ml-7 rounded-lg border border-pink-200 bg-pink-50/60 p-3 flex items-start gap-3 flex-wrap"
    data-testid="onboarding-instagram-panel"
  >
    <Instagram className="text-pink-600 shrink-0 mt-0.5" size={16} />
    <div className="text-xs text-navy/80 leading-relaxed flex-1 min-w-[200px]">
      <span className="font-semibold text-navy">Bloom attribution runs on Instagram.</span> Connect your
      Business or Creator account so QR scans, follower growth and giveaway entries from your wrap are
      tracked automatically.
    </div>
    <button
      type="button"
      onClick={onConnect}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-pink-600 text-white text-xs font-semibold hover:bg-pink-700 transition-colors"
      data-testid="onboarding-connect-instagram-btn"
    >
      <Instagram size={12} /> Connect Instagram
    </button>
  </div>
);

const OnboardingChecklist = ({ data, onConnectInstagram }) => {
  if (!data || !data.show) return null;
  const pct = Math.round((data.completed / data.total) * 100);

  return (
    <div
      className="bg-white rounded-2xl border border-navy/10 shadow-sm p-5 mb-6"
      data-testid="onboarding-checklist"
    >
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="text-navy font-bold text-base">Get your campaign humming</h3>
          <p className="text-navy/60 text-xs">
            {data.completed} of {data.total} complete · {pct}%
          </p>
        </div>
        <span className="text-xs px-2.5 py-1 rounded-full bg-amber-50 border border-amber-300 text-amber-700 font-semibold">
          Setup
        </span>
      </div>
      <div className="w-full h-2 bg-navy/10 rounded-full overflow-hidden mb-4">
        <div
          className="h-full bg-emerald-500 transition-all duration-500"
          style={{ width: `${pct}%` }}
          data-testid="onboarding-progress-bar"
        />
      </div>
      <ul className="space-y-2">
        {data.items.map((item) => (
          <li
            key={item.id}
            data-testid={`onboarding-item-${item.id}`}
            className={`text-sm ${item.done ? 'text-navy/50' : 'text-navy'}`}
          >
            <div className={`flex items-start gap-3 ${item.done ? 'line-through' : ''}`}>
              {item.done ? (
                <CheckCircle2 className="text-emerald-600 shrink-0 mt-0.5" size={18} />
              ) : (
                <Circle className="text-navy/30 shrink-0 mt-0.5" size={18} />
              )}
              <span>{item.label}</span>
            </div>
            {item.id === 'instagram' && !item.done && <ConnectInstagramPanel onConnect={onConnectInstagram} />}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OnboardingChecklist;
